<template>
    <div class="fade-in">
        <div v-if="medical" class="row">
            <div class="col-md-4 mb-3">
                <div class="border border-light rounded p-3 h-100">
                    <small class="text-muted d-block">Blood Type</small>
                    <div class="font-weight-bold">{{ medical.bloodType || '--' }}</div>
                </div>
            </div>
            <div class="col-md-4 mb-3">
            <div class="border border-light rounded p-3 h-100">
                <small class="text-muted d-block">Pregnant</small>
                <i v-if="medical.isPregnant" class="mdi mdi-check-circle text-warning"></i>
                <i v-else class="mdi mdi-close-circle text-secondary"></i>
            </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="border border-light rounded p-3 h-100">
                    <small class="text-muted d-block">Pregnant Month</small>
                    <div class="font-weight-bold">{{ medical.pregnantMonth || '--' }}</div>
                </div>
            </div>
            <div class="col-md-12 mb-3">
                <div class="border border-light rounded p-3 h-100">
                    <div class="d-flex flex-wrap justify-content-between align-items-center">
                        <small class="text-muted">Physical Impairment / Disease</small>
                        <i v-if="medical.physicalImpairmentDisease" class="mdi mdi-check-circle text-warning font-size-16 ml-2"></i>
                        <i v-else class="mdi mdi-close-circle text-secondary ml-2" ></i>
                    </div>
                    <div class="text-muted mt-1">{{ medical.physicalImpairmentDiseaseRemark || '--' }}</div>
                </div>
            </div>
            <div class="col-md-12 mb-3">
                <div class="border border-light rounded p-3 h-100">
                    <div class="d-flex flex-wrap justify-content-between align-items-center">
                        <small class="text-muted">Serious Illness</small>
                        <i v-if="medical.seriousIllness" class="mdi mdi-check-circle text-warning font-size-16 ml-2"></i>
                        <i v-else class="mdi mdi-close-circle text-secondary ml-2"></i>
                    </div>
                    <div class="text-muted mt-1">{{ medical.seriousIllnessRemark || '--' }}</div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="border border-light rounded p-3 h-100">
                    <div class="d-flex flex-wrap justify-content-between align-items-center">
                        <small class="text-muted">Medication Allergy</small>
                        <i v-if="medical.medicationAllergy" class="mdi mdi-check-circle text-warning font-size-16 ml-2"></i>
                        <i v-else class="mdi mdi-close-circle text-secondary ml-2"></i>
                    </div>
                    <div class="text-muted mt-1">{{ medical.medicationAllergyRemark || '--' }}</div>
                </div>
            </div>
        </div>
        <b-alert
            v-else
            show
            variant="warning"
            class="text-center"
        >
            <i class="mdi mdi-alert-circle-outline"></i> {{ $t('message.noResultsFound') }}
        </b-alert>
    </div>
</template>
<script>
export default {
    props: {
        medical: {
            type: Object,
            required: false,
        },
    },
}
</script>
